<template>
  <div>
    <ul
      class="md:h-8 md:flex md:space-x-8 md:mx-auto md:justify-center mt-3 md:mt-6"
    >
      <li
        v-for="tag in getSelectedTags"
        :key="tag.id"
        class="filter-item inline-block font-medium cursor-pointer mt-6 md:mt-0"
        @click="toggleTag(tag.id)"
      >
        <span>
          <span
            v-if="tag.id.includes('Face')"
            class="face"
            :class="tag.id.toLowerCase().replaceAll(' ', '-')"
          />
          {{ tag.id }}
        </span>
        <span class="ml-3 mr-7 relative -top-px md:mr-0">x</span>
      </li>
    </ul>
  </div>
</template>

<script>
import useFilterToggleTag from '../composables/useFilterToggleTag'
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("collection");

export default {
  setup() {
    const { toggleTag } = useFilterToggleTag()
    return { toggleTag }
  },
  computed: mapGetters(["getSelectedTags"]),
};
</script>

<style scoped>
.filter-item {
  line-height: 20px;
  margin-top: -2px
}
.face {
  height: 14px;
  width: 24px;
  position: relative;
  top: 3px;
}
</style>